var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShareIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_814_251)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 10.4716C20 9.43869 19.1633 8.60205 18.1304 8.60205H15.1694C14.7815 8.60205 14.4683 8.91521 14.4683 9.30315C14.4683 9.69109 14.7815 10.0042 15.1694 10.0042H18.1304C18.3875 10.0042 18.5978 10.2146 18.5978 10.4716V20.1304C18.5978 20.3875 18.3875 20.5978 18.1304 20.5978H6.16964C5.91258 20.5978 5.70225 20.3875 5.70225 20.1304V10.4716C5.70225 10.2146 5.91258 10.0042 6.16964 10.0042H9.13062C9.51856 10.0042 9.83171 9.69109 9.83171 9.30315C9.83171 8.91521 9.51856 8.60205 9.13062 8.60205H6.16964C5.13669 8.60205 4.30005 9.43869 4.30005 10.4716V20.1304C4.30005 21.1634 5.13669 22 6.16964 22H18.1304C19.1633 22 20 21.1634 20 20.1304V10.4716Z",
    fill: "#565656"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0214 16.237C12.4094 16.237 12.7225 15.9238 12.7225 15.5359V4.22482L15.8424 6.89834C16.1228 7.16476 16.5669 7.15307 16.8333 6.8703C17.0997 6.58986 17.088 6.14583 16.8053 5.87941C16.7889 5.86305 16.7702 5.84903 16.7538 5.83501L12.4795 2.16826C12.2177 1.94391 11.8298 1.94391 11.568 2.16826L7.28901 5.83501C6.98286 6.07104 6.92678 6.51274 7.16515 6.81888C7.40352 7.12503 7.84288 7.18112 8.14902 6.94274C8.16772 6.92872 8.18408 6.9147 8.20044 6.89834L11.3203 4.22482V15.5359C11.3203 15.9238 11.6335 16.237 12.0214 16.237Z",
    fill: "#565656"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_814_251"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.6999,
    height: 20,
    fill: "white",
    transform: "translate(4.30005 2)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareIcon);
export default __webpack_public_path__ + "static/media/shareIcon.19bef681.svg";
export { ForwardRef as ReactComponent };